function getStorage(key) {
  return localStorage.getItem(key) || sessionStorage.getItem(key) || ''
}

function setStorage(key, value, remember) {
  if (remember) {
    localStorage.setItem(key, value)
    sessionStorage.removeItem(key)
  } else {
    sessionStorage.setItem(key, value)
    localStorage.removeItem(key)
  }
}

function removeStorage(key) {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}

export default {
  state: {
    token: getStorage('token'),
    username: getStorage('username'),
    realName: getStorage('realName'),
    role: getStorage('role'),
    warehouseIds: JSON.parse(getStorage('warehouseIds') || '[]')
  },
  mutations: {
    SET_TOKEN(state, { token, rememberMe }) {
      state.token = token
      setStorage('token', token, rememberMe)
    },
    SET_USER(state, { username, realName, role, warehouseIds, rememberMe }) {
      state.username = username
      state.realName = realName
      state.role = role
      state.warehouseIds = warehouseIds || []
      setStorage('username', username, rememberMe)
      setStorage('realName', realName, rememberMe)
      setStorage('role', role, rememberMe)
      setStorage('warehouseIds', JSON.stringify(warehouseIds || []), rememberMe)
    },
    LOGOUT(state) {
      state.token = ''
      state.username = ''
      state.realName = ''
      state.role = ''
      state.warehouseIds = []
      ;['token', 'username', 'realName', 'role', 'warehouseIds'].forEach(removeStorage)
    }
  }
}
